import globalTheme, { muiTheme } from '../global'

const Table = {
	MuiTableCell: {
		styleOverrides: {
			body: {
				color: globalTheme.palette.grey.main,
				borderBottom: '1px solid ' + globalTheme.palette.grey.light,
				fontWeight: muiTheme.typography.fontWeightRegular,
			},
			head: {
				backgroundColor: globalTheme.palette.grey.active,
				borderBottom: 0,
				color: globalTheme.palette.primary.main,
				fontWeight: muiTheme.typography.fontWeightBold,
				'.MuiCheckbox-root svg': {
					color: globalTheme.palette.grey.dark,
				},
			},
			root: {
				lineHeight: 18 / 14,
				minWidth: 113,
				padding: globalTheme.spacing(3, 4),
			},
		},
	},
	MuiTableRow: {
		styleOverrides: {
			root: {
				'&.MuiTableRow-hover:hover': {
					backgroundColor: globalTheme.palette.grey.lighter,
				},
			},
		},
	},
	MuiTableSortLabel: {
		styleOverrides: {
			icon: {
				height: 20,
				width: 20,
			},
			root: {
				'&.Mui-active ': {
					color: globalTheme.palette.primary.main,
					' .MuiTableSortLabel-icon': {
						color: globalTheme.palette.primary.main,
					},
				},
				'&:not(.Mui-active):hover ': {
					color: globalTheme.palette.grey.main,
				},
			},
		},
	},
}

export default Table
